<div class="clearfix"></div>
<div class="container-fluid px-0">

  <div class="main-row">
    <main role="main" class="ml-sm-auto p-0 bg-light main-container">
      <nav class="navbar navbar-light bg-white border border-right-0 border-top-0 text-right">
        <div class="col-md-12">
          <div class="col-md-1" style="float:right">
            <span id="list_toggle" class="style-view" (click)="shouldShowcolumn = !shouldShowcolumn">
              <!--img [ngClass]="{'listicon': shouldShowcolumn, 'columnicon': !shouldShowcolumn}"/-->
              <img *ngIf="shouldShowcolumn" src="{{imgdynamicurl}}/assets/img/col-icon.png" />
              <img *ngIf="!shouldShowcolumn" src="{{imgdynamicurl}}/assets/img/list-icon.png" />
              <!--i class="las la-list"
            [ngClass]="{'la-list': shouldShowcolumn, 'la-border-all': !shouldShowcolumn}"></i-->
            </span>
          </div>
          <div class="col-md-11">
            <!-- <marquee style="width: 100%;" scrolldelay="200">{{'MENU.MARQUEE' | translate}}</marquee> -->
            <marquee style="width: 100%;" scrolldelay="200">All DEWA applications will be available for access through this portal in the future. Applications will be added here in phases.</marquee>
          </div>
        </div>
      </nav>

      <div class="main-content container-fluid scrollcontainer">
        <div *ngIf="allapps.length==0" class="row">
          <div class="col-lg-12">
            <h4 class="font-weight-bold text-lightdark my-3">No Apps Found</h4>
            <h5 style="display:none" class="font-weight-light text-lightdark my-3">No recent activity</h5>
          </div>
        </div>

        <div class="row justify-content-md-center">
          <img [hidden]="!imageLoader" src="{{imgdynamicurl}}/assets/img/loader.gif" style="width:100px;height:100px" />
        </div>
        <!--User Application List Sectionwise-->
        <!-----------------------All Application Categorywise---------------------------------------->
        <div *ngFor="let apps of allapps">
          <div class="row" style="display:none">
            <div class="col mb-3">
              <h4 class="font-weight-bold text-lightdark mt-2 float-left">{{apps.appCategory}}</h4>
              <!--a type="button" class="text-nowrap mt-5 float-right" data-toggle="modal" (click)="EditSection(sectioninfo)" data-target="#add-department">
                <img src="../mw/assets/img/add-dark.png" height="24" class="mr-3">
              </a-->
            </div>
          </div>
          <div class="row approval-home-links row-cols-1 row-cols-md-5 g-4 mt-3 row-cols-md-1"
            [ngClass]="{'row-cols-md-1': shouldShowcolumn, 'row-cols-md-5': !shouldShowcolumn}">
            <div *ngFor="let appln of apps.applicationInfo" class="col mb-3">
              <!--div class="card h-60" style="cursor:pointer"-->
              <a href="{{appln.applnurl}}" target="_blank">
                <div class="card" [ngClass]="{'h-60':!shouldShowcolumn,'h-90':shouldShowcolumn}" style="cursor:pointer">
                  
                  <!--div class="content-overlay justify-content-center"><span>Coming Soon</span></div-->
                  <!--div class="card-overlay"><span>Coming Soon</span-->
                  <!--- To be reverted-------->
                  <!--div class="card-body rounded" (click)="addToRecent(appln)" [ngClass]="{'card1':shouldShowcolumn,'card2':!shouldShowcolumn}"-->
                  <!--div class="card-overlay rounded"><span>Coming Soon</span-->
                    <!-- (click)="addToRecent(appln)" -->
                  <div class="card-body rounded" (click)="addToRecent(appln)" 
                    [ngClass]="{'card1':shouldShowcolumn,'card2':!shouldShowcolumn}">
                    <div class="card-title mb-0 text-truncate" style="font-size:19px">{{appln.applnname}}
                      <img *ngIf="shouldShowcolumn"
                        [ngClass]="{'card-image': !shouldShowcolumn, 'card-image-list': shouldShowcolumn}"
                        src="{{imgdynamicurl}}/assets/img/arrow.png" />
                      <!--commenting because its causing alignment issues-->
                      <!--img *ngIf="!shouldShowcolumn" class="card-image" src="../mw/assets//img/arrow.png"/-->
                    </div>
                    <img *ngIf="!shouldShowcolumn" class="card-image" src="{{imgdynamicurl}}/assets/img/arrow.png" />
                    <!--span>Coming Soon</span-->
                    <!--/div-->
              
            </div>
          
            <!--/div-->
          
          </div>
        </a>
        </div>
      </div>
  </div>

  <footer *ngIf="!imageLoader"
    style="width:100%;position: fixed; bottom: 4px;margin-left: -19px;margin-right: -15px;margin-bottom: -10px;margin-top: -15px;padding-bottom:10px!important;">
    <div class="row">
      <div class="col-md-11">

        <!--p class="pull-left"-->
        © 2023 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
        <!-- {{'MENU.FOOTER' | translate}} -->
        <!--/p-->
      </div>
      <!--div class="col-md-1">
            <p class="pull-right">
              version 1.0
            </p>
          </div-->
    </div>
    <div class="clearfix"></div>
  </footer>
</div>
</main>
</div>
</div>